var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 16,
    viewBox: "0 0 35 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13695_23606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32796 0V13.3465L4.11724 16H4.08594V0H7.32796Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46163 5.39946L5.9707 1.88867L4.08379 0.000839142L0.574714 3.51162L2.46163 5.39946Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7436 7.88916L24.4252 11.8807L22.3052 9.21968L21.2383 7.87538L24.1798 4.37495L24.5028 3.98782L25.1465 3.2261L26.4964 1.62246H26.4901L27.8388 0.0175781H34.2852L32.9529 1.62246L31.6205 3.2261L27.7436 7.88916Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4599 15.9825H27.6891L25.9498 13.8001L24.6763 12.1964L24.6562 12.1714L27.9809 8.1748L28.4643 8.75737L31.3231 12.1964H31.3068L32.6417 13.8001L34.4599 15.9825Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2468 0.0219727L13.3141 3.23049H10.166V0.0219727H16.2468Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1706 0.0219727L12.6985 7.49891H12.2402L19.7123 0.0219727H20.1706Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5741 9.6039C20.5741 13.1244 17.7215 15.9783 14.2027 15.9783C12.4083 15.9783 10.7879 15.2367 9.63086 14.0427L12.1228 11.5496C12.64 12.1071 13.38 12.4541 14.2015 12.4541C15.7755 12.4541 17.0503 11.1775 17.0503 9.6039C17.0503 9.18545 16.9602 8.78955 16.7974 8.43124C16.6421 8.08546 16.4204 7.77726 16.1462 7.52168L18.6369 5.02979C19.5635 5.92932 20.2172 7.10824 20.4639 8.43124C20.5353 8.81085 20.5716 9.20299 20.5716 9.6039H20.5741Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1572 1.31986C17.4781 1.31986 17.7382 1.0596 17.7382 0.738544C17.7382 0.417491 17.4781 0.157227 17.1572 0.157227C16.8363 0.157227 16.5762 0.417491 16.5762 0.738544C16.5762 1.0596 16.8363 1.31986 17.1572 1.31986Z",
    fill: "#2D2F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0517 7.49857C15.3726 7.49857 15.6328 7.23831 15.6328 6.91725C15.6328 6.5962 15.3726 6.33594 15.0517 6.33594C14.7308 6.33594 14.4707 6.5962 14.4707 6.91725C14.4707 7.23831 14.7308 7.49857 15.0517 7.49857Z",
    fill: "#2D2F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13695_23606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.07755df1d3012b3478645dc2610c9f64.svg";
export { ForwardRef as ReactComponent };